<template>
    <div class="form-field form-publication-state" :rel="name" v-bind:class="{'form-required': requiredForm}">
        <div class="form-label" v-if="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
              <div>
                <label>
                  <input type="radio" v-model="internalValue" name="publication" :value="2"/>
                  <span>Brouillon</span>
                </label>
                <label class="unpublished">
                  <input type="radio" v-model="internalValue" name="publication" :value="0"/>
                  <span>Non publié</span>
                </label>
                <label class="published">
                  <input type="radio" v-model="internalValue" name="publication" :value="1"/>
                  <span>Publié</span>
                </label>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PublicationState',
        props: ['value', 'label', 'name', 'placeholder', 'index', 'callback','required', 'disabled'],
        data: function () {
            return {
                internalValue: 0,
                width: 40
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.onChange = this.callback ? true : false;
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                if(typeof newVal === "undefined"){
                    newVal = 0;
                }
                this.internalValue = newVal;
            },
            'internalValue'(newVal, oldVal) {
                var val = this.internalValue
                this.$emit('input', val);
                this.$emit('event', {index:this.index, value:val});
                if( this.onChange ){
                    this.callback(val)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/PublicationState.vue